import { ValidationRegExp } from "./regex.contans";

export const VALIDATION_SCHEMA = {
  toolInfo: {
    tool: {
      required: "Please, select at least one value",
    },
    requestType: {
      required: "Please, select at least one value",
    },
    required: {
      required: "This field is required",
    },
    oneValue: {
      required: "Please, select at least one value",
    },
  },
  name: {
    required: "Please enter First name",
    minLength: {
      value: 2,
      message: "Field value should be: 2-250 characters",
    },
    maxLength: {
      value: 250,
      message: "Field value should be: 2-250 characters",
    },
    pattern: {
      value: ValidationRegExp.name,
      message: "Remove restrict symbol",
    },
  },
  last_name: {
    required: "Please enter Last name",
    minLength: {
      value: 2,
      message: "Field value should be: 2-250 characters",
    },
    maxLength: {
      value: 250,
      message: "Field value should be: 2-250 characters",
    },
    pattern: {
      value: ValidationRegExp.name,
      message: "Remove restrict symbol",
    },
  },
  email: {
    required: "Please enter email",
    pattern: {
      value: ValidationRegExp.email,
      message: "Please enter valid email",
    },
  },
  company: {
    minLength: {
      value: 2,
      message: "Field value should be: 2-250 characters",
    },
    maxLength: {
      value: 250,
      message: "Field value should be: 2-250 characters",
    },
    pattern: {
      value: ValidationRegExp.name,
      message: "Remove restrict symbol",
    },
  },
  phone: {
    required: "Please enter phone number",
    minLength: {
      value: 8,
      message: "Min length with country code is 8 characters",
    },
  },
  message: {
    required: "Please enter message",
    minLength: {
      value: 2,
      message: "Field value should be: 2-1500 characters",
    },
    maxLength: {
      value: 1500,
      message: "Field value should be: 2-1500 characters",
    },
  },
  pattern: {
    value: ValidationRegExp.text,
    message: "Remove restrict symbol",
  },
};
